import type { VoidFunctionComponent } from 'react'

import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
} from '@monthio/react-components'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface TestUser {
	cpr: string
	userName: string
	authenticationLink: string
}

const testUsers: TestUser[] = [
	{
		cpr: '0707614285',
		userName: 'Jørgen48867',
		authenticationLink:
			'https://pp.mitid.dk/test-tool/code-app-simulator/#/15c9276c-475d-45ca-9e3c-96e8792c7c28/details/A-0378-0456-6724',
	},
	{
		cpr: '0706614184',
		userName: 'Palmer4325',
		authenticationLink:
			'https://pp.mitid.dk/test-tool/code-app-simulator/#/15d754cb-e788-4dfc-b52c-381ef7df527e/details/A-5574-5042-1826',
	},
]

export const MitIdTestUsersTable: VoidFunctionComponent = () => {
	const { t } = useTranslation()
	return (
		<Table>
			<TableHead>
				<TableRow>
					<TableCell align="center">
						{t('mit-id-test-users-table-cpr')}
					</TableCell>
					<TableCell align="center">
						{t('mit-id-test-users-table-user-name')}
					</TableCell>
					<TableCell align="center">
						{t('mit-id-test-users-table-auth-link')}
					</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{testUsers.map((user) => (
					<TableRow key={user.cpr}>
						<TableCell align="center">{user.cpr}</TableCell>
						<TableCell align="center">{user.userName}</TableCell>
						<TableCell align="center">
							<a
								href={user.authenticationLink}
								target="_blank"
								rel="noopener noreferrer"
							>
								{t('mit-id-test-users-table-auth-link')}
							</a>
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	)
}
